module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAElBMVEUAAAD5lB35lR34lB35liD4lh8vMCz5AAAABnRSTlMA/lfjUEnRZxQvAAAAeUlEQVQ4y+XSyQ2AMAxEUUQHDhQQSkCCAhAl0H8vHNDIWP8wBSQnR87L4ngafDxHxvf5S+zRFc6xlERTuJXEFdEFYv0iTZuAluQ8V5AkKIRARABEAEQARABEACSBT+RW9nBe1z6QJbFFZNndR/FrXTOwfWzDsUXHHi+knhB5HexKhAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x@2x.png
// module id = 675
// module chunks = 1